<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10 mgb-20">
      <el-form ref="form" :model="form" label-width="100px" :inline="true">
        <el-form-item label="设备名称">
          <el-input
            v-model="form.name"
            placeholder="请输入设备名称"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属企业">
          <el-select
            clearable
            v-model="form.companyId"
            filterable
            placeholder="全部"
          >
            <el-option
              v-for="v in companyIdArr"
              :key="v.id"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.shebei"
            placeholder="请输入设备编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设备clientId">
          <el-input
            v-model="form.clientId"
            placeholder="请输入设备clientId"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="上报时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = { companyId: '', startTime: '', endTime: '' };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="equipmentNum" label="设备名称">
        <template slot-scope="scope">
          <span v-text="scope.row.name ? scope.row.name : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="clientId" label="设备clientId"> </el-table-column>

      <!-- <el-table-column prop="equipmentNum" label="所属企业">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.futureCustomerName
                ? scope.row.futureCustomerName
                : '- -'
            "
          ></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="equipmentNum" label="所属分区">
        <template slot-scope="scope">
          <span
            v-text="scope.row.regionName ? scope.row.regionName : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentNum" label="联网状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.status == 1
                ? '在线'
                : scope.row.status == 0
                ? '离线'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentNum" label="开机状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.onoff == 1
                ? '开机'
                : scope.row.onoff == 0
                ? '关机'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>

      <el-table-column prop="error" label="故障码"> </el-table-column>
      <el-table-column prop="errorState" label="代表状态"> </el-table-column>
      <el-table-column prop="createTime" label="上报时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      errorState: [
        {
          error: "1",
          state: "箱体内温度故障",
        },
        {
          error: "2",
          state: "箱体外温度故障",
        },
        {
          error: "31",
          state: "水箱1空",
        },
        {
          error: "32",
          state: "水箱2空",
        },
        {
          error: "33",
          state: "水位故障",
        },
        {
          error: "4",
          state: "低压报警",
        },
        {
          error: "51",
          state: "流量1报警",
        },
        {
          error: "52",
          state: "流量2报警",
        },
        {
          error: "53",
          state: "流量3报警",
        },
        {
          error: "7",
          state: "制水故障",
        },
        {
          error: "8",
          state: "联网异常",
        },
        {
          error: "9",
          state: "订单数据超限",
        },
        {
          error: "16",
          state: "实物卡错误",
        },
        {
          error: "10",
          state: "原水TDS超标",
        },
        {
          error: "11",
          state: "纯水TDS超标",
        },
        {
          error: "12",
          state: "高压故障",
        },
        {
          error: "21",
          state: "即热一故障",
        },
        {
          error: "22",
          state: "即热二故障",
        },
        {
          error: "23",
          state: "制冷超时",
        },
        {
          error: "24",
          state: "预热超时",
        },
      ],
      form: {
        companyId: "",
      },
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      tableData: [],
      zoneArr: [],
      companyIdArr: [],
      roleId: null,
      companyId: null,
    };
  },
  created() {
    this.getROLE();

    // this.getcompanyId();
    setTimeout(() => {
      this.getList();
    }, 200);
    this.getZone();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
        this.companyId = token.companyId;
      }
    },
    getcompanyId() {
      if (this.roleId == 21) {
        this.$api.shebei.sellQiyePull().then((res) => {
          this.companyIdArr = res.data;
        });
      } else {
        this.$api.enterprise.enterpriseListPullNew().then((res) => {
          this.companyIdArr = res.data;
        });
      }
    },
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      let arr = [];
      this.companyIdArr.forEach((v) => {
        arr.push(v.id);
      });
      this.$api.shebei
        .troubleList({
          pageNum: this.page,
          pageSize: this.pageSize,
          equipmentNum: this.form.shebei,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          regionId: this.form.fenqu,
          futureCustomerId: this.companyId,
          name: this.form.name,
          clientId: this.form.clientId,
        })
        .then((res) => {
          if (res.code === 200) {
            const errorMap = this.errorState.reduce((map, item) => {
              map[item.error] = item.state;
              return map;
            }, {});
            res.data.list.forEach((item) => {
              if (Number(item.error) == 0) {
                item.errorState = "正常";
              } else {
                const errors = item.error.split(",");
                item.errorState = errors
                  .map((a) => errorMap[a] || "")
                  .filter((state) => state)
                  .join(", ");
              }
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },

    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped></style>
